<template>
  <el-card class="box-card">
    <el-form ref="formInfo" class="global-form2" :model="formInfo"  label-width="120px" :rules = "rulesForm">
      <el-form-item label="供应商名称" prop="supplierName">
        <el-input placeholder="请输入供应商名称" v-model="formInfo.supplierName" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="供应商类型" prop="supplierType">
        <el-select v-model="formInfo.supplierType" clearable filterable placeholder="请选择供应商类型">
          <el-option
            v-for="item in typeList"
            :key="item.dicCode"
            :label="item.dicValue"
            :value="item.dicCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商级别" prop="supplierLevel">
        <el-input placeholder="请输入供应商级别" v-model="formInfo.supplierLevel" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="通讯邮编" prop="supplierPostal">
        <el-input placeholder="请输入通讯邮编" v-model="formInfo.supplierPostal" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="area">
          <el-cascader
            v-model="addrInfo"
            :options="addrList"
            :props="{value: 'label', children: 'children', label: 'label'}"
            @change="areaChange"
            placeholder="请选择省市区"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="address">
          <el-autocomplete
            v-model="formInfo.address"
            :disabled="formInfo.area === '' "
            :fetch-suggestions="addrFetch"
            :maxlength='50'
            autocomplete="new-password"
            placeholder="请输入详细地址"
            @select="addrChange">
            <template v-slot="{ item }">
              <span>{{ item.name }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="经营范围" prop="operationScope">
          <el-input
            type="textarea"
            maxlength="200"
            placeholder="请输入经营范围"
            :rows="6"
            show-word-limit
            v-model="formInfo.operationScope"
          ></el-input>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contactName">
        <el-input placeholder="请输入联系人姓名" v-model="formInfo.contactName" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="contactMobile">
        <el-input placeholder="请输入联系人电话" v-model="formInfo.contactMobile" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { phoneAndFixedLine, email } from '@/utils/validate'
export default {
  name: 'SuppliermanageList',
  data () {
    return {
      typeList: [],
      formInfo: {},
      rulesForm: {
        supplierName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        supplierType: [
          { required: true, message: '请输入供应商类型', trigger: 'change' }
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'change' }
        ],
        contactMobile: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { validator: phoneAndFixedLine, trigger: ['change', 'blur'] }
        ],
        mail: [
          { validator: email, trigger: ['change', 'blur'] }
        ]
      },
      loading: false,
      addrList: [],
      addrInfo: []
    }
  },
  computed: {
    supplierId () {
      return this.$route.query.supplierId || ''
    }
  },
  created () {
    this.getConfigList()
    this.getAddrList()
    this.supplierId && this.getDetail()
  },
  methods: {
    // 获取供应商类型
    getConfigList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'supplierType' }).then(res => {
        this.typeList = res.supplierType || []
      })
    },
    // 获取地址信息
    getAddrList () {
      this.$axios.get(this.$apis.common.getRegion).then(res => {
        this.addrList = res || []
      })
    },
    areaChange () {
      if (this.addrInfo.length === 3 && this.addrInfo[2] !== '') {
        this.formInfo.province = this.addrInfo[0] || ''
        this.formInfo.city = this.addrInfo[1] || ''
        this.formInfo.area = this.addrInfo[2] || ''
      } else {
        this.formInfo.province = ''
        this.formInfo.city = ''
        this.formInfo.area = ''
      }
    },
    // 详细地址输入
    addrFetch (queryString, cb) {
      AMap.plugin(['AMap.AutoComplete', 'AMap.Geocoder'], () => {
        // 实例化Autocomplete
        const autoComplete = new AMap.AutoComplete({
          city: this.formInfo.city
        })
        autoComplete.search(this.formInfo.area + queryString, (status, result) => {
          const res = result
          if (status === 'complete') {
            cb(res.tips)
          }
        })
      })
    },
    // 点击详细地址下拉
    addrChange (data) {
      this.formInfo.address = data.name
    },
    getDetail () {
      this.loading = true
      this.$axios.get(this.$apis.system.selectYhSupplierBySupplierId, {
        supplierId: this.supplierId
      }).then((res) => {
        this.formInfo = res || {}
        this.addrInfo = [res.province, res.city, res.area]
      }).finally(() => {
        this.loading = false
      })
    },
    onSubmit () {
      (this.$refs.formInfo).validate((valid) => {
        if (valid) {
          const url = this.supplierId ? this.$apis.system.updateYhSupplier : this.$apis.system.insertYhSupplier
          // 编辑去除字段
          delete this.formInfo.supplierTypeName
          this.$axios.post(url, this.formInfo).then(() => {
            this.$message.success('保存成功')
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .title {
    text-align: left;
    margin-bottom: 25px;
    font-weight: bold;
    font-size: 14px;
  }

  .form-item-btn {
    margin-top: 30px;
    margin-left: 30px;
    .btn {
      width: 60px;
      &.cancel-btn {
        margin-left: 10px;
      }
    }
  }
</style>
